export default __webpack_public_path__ + "static/media/close-small.09ae12ab.svg";